import {useTranslation} from "react-i18next";
import {RatingBlock} from "../../../../../components/RatingBlock";
import TestimonialCard from "../../../../../components/TestimonialCard";
import React from "react";
import {SubscriptionDetailContent} from "../SubscriptionDetail";

const TestimonialsBlock = ({ comments }: { comments?: SubscriptionDetailContent['comments'] }) => {
    const { t } = useTranslation();
    if (!comments || comments.length === 0) return null;
    return (
        <div className="testimonials-block">
            <p className="testimonials-title">{t('subscription.testimonialsTitle')}</p>
            <RatingBlock
                rating1={0}
                rating2={0}
                rating3={0}
                rating4={20}
                rating5={80}
                reviewsCount={1249}
                style={{marginBottom: '20px'}}
            />
            {comments.map((t, i) => (
                <TestimonialCard key={i} avatar={t.avatar} name={t.name} rating={t.rating} text={t.text} />
            ))}
        </div>
    );
};

export default TestimonialsBlock;
